export class RequestConfig {
  static options: any = {
    withCredentials: true
  };
}
